export function readFile (file) {
  return new Promise((resolve, reject) => {
    if (file.size > 524288) {
      return reject(new Error('File size exceed the allowed limit'))
    }
    const reader = new window.FileReader()
    reader.addEventListener('load', () => resolve(reader.result), false)
    reader.readAsDataURL(file)
  })
}

export function createImage (url) {
  return new Promise((resolve, reject) => {
    const image = new window.Image()
    image.addEventListener('load', () => resolve(image))
    image.addEventListener('error', error => reject(error))
    image.setAttribute('crossOrigin', 'use-credentials')
    image.src = url
  })
}

export function createImageBase64 (img) {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas')
    canvas.width = img.width
    canvas.height = img.height
    const ctx = canvas.getContext('2d')
    ctx.drawImage(img, 0, 0)
    const dataURL = canvas.toDataURL('image/png')
    resolve(dataURL)
  })
}

function drawingImage (image, pixelCrop) {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas')
    const pxCropWidth = pixelCrop.width
    const pxCropHeight = pixelCrop.height
    canvas.width = pxCropWidth
    canvas.height = pxCropHeight
    const imageObject = new window.Image()
    imageObject.src = image
    const ctx = canvas.getContext('2d')

    imageObject.addEventListener('load', () => {
      let base64Img = ''
      ctx.drawImage(
        imageObject,
        pixelCrop.x,
        pixelCrop.y,
        pxCropWidth,
        pxCropHeight,
        0,
        0,
        pxCropWidth,
        pxCropHeight
      )
      base64Img = canvas.toDataURL('image/jpeg')
      resolve(base64Img)
    })
  })
}

export async function getCroppedImg (image, pixelCrop) {
  let base64Image = ''
  if (pixelCrop) {
    const canvas = document.createElement('canvas')
    const pxCropWidth = pixelCrop.width
    const pxCropHeight = pixelCrop.height
    canvas.width = pxCropWidth
    canvas.height = pxCropHeight
    const imageObject = new window.Image()
    imageObject.src = image
    const imageDrawn = await drawingImage(image, pixelCrop)
    base64Image = imageDrawn
  } else {
    base64Image = image
  }
  return base64Image
}
